import React, { useCallback, useEffect, useState } from "react";
import { PageHeader, PhxButton } from "@/design-system";
import { useOffline } from "@/offline/OfflineProvider";

/** Queued offline actions, and the ones the server rejected ("needs attention"). */
export default function SyncPage() {
  const { outbox, sync, refreshCounts, syncing } = useOffline();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => setItems(await outbox.list()), [outbox]);
  useEffect(() => { load(); }, [load, syncing]);

  const act = async (fn) => { await fn(); await refreshCounts(); await load(); };

  return (
    <div data-testid="sync-page">
      <PageHeader title="Sync" />
      <PhxButton onClick={() => act(sync)} disabled={syncing}>Sync now</PhxButton>
      {items.length === 0 ? (
        <p className="text-sm text-slate-500 mt-4" data-testid="sync-empty">Everything is synced.</p>
      ) : (
        <ul className="divide-y border bg-white mt-4">
          {items.map((i) => (
            <li key={i.id} className="p-3 text-sm flex items-center justify-between" data-testid={`outbox-${i.id}`}>
              <span>
                <span className="font-medium">{i.provisionalNumber}</span> — {i.status === "pending" ? "waiting to sync" : "needs attention"}
                {i.error && <span className="block text-red-600">{i.error}</span>}
              </span>
              {i.status === "needs_attention" && (
                <span className="flex gap-2">
                  <PhxButton onClick={() => act(() => outbox.retry(i.id))}>Retry</PhxButton>
                  <PhxButton variant="secondary" onClick={() => act(() => outbox.discard(i.id))}>Discard</PhxButton>
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
